export const widths = [16, 18, 20, 22, 24, 26];
